import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LOGO_URL = 'https://public.readdy.ai/ai/img_res/c98bf352-e1ac-48f2-985a-53503ade1afd.png';

export default function Footer() {
  const { t } = useTranslation();

  const services = [
    t('footer.s1'),
    t('footer.s2'),
    t('footer.s3'),
    t('footer.s4'),
    t('footer.s5'),
    t('footer.s6'),
  ];

  const quickLinks = [
    { label: t('nav.home'), path: '/' },
    { label: t('nav.services'), path: '/services' },
    { label: t('nav.contact'), path: '/contact' },
  ];

  return (
    <footer style={{ backgroundColor: '#F4F6F9' }} className="border-t border-gray-200">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <img src={LOGO_URL} alt="ArmeniaSettle" className="w-9 h-9 object-contain" />
              </div>
              <span className="font-bold text-gray-900 text-base" style={{ fontFamily: "'Inter', sans-serif" }}>
                ArmeniaSettle
              </span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed mb-6">
              {t('footer.tagline')}
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://t.me/haykagab"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-blue-100 hover:text-blue-600 text-gray-500 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-telegram-line text-sm"></i>
              </a>
              <a
                href="mailto:haykagab@gmail.com"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-blue-100 hover:text-blue-600 text-gray-500 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 mb-5 uppercase tracking-wider">{t('footer.services')}</h4>
            <ul className="flex flex-col gap-3">
              {services.map((s) => (
                <li key={s}>
                  <Link to="/services" className="text-sm text-gray-500 hover:text-blue-600 transition-colors duration-200 cursor-pointer">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 mb-5 uppercase tracking-wider">{t('footer.navigation')}</h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-gray-500 hover:text-blue-600 transition-colors duration-200 cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 mb-5 uppercase tracking-wider">{t('footer.contact')}</h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-blue-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">{t('footer.email')}</p>
                  <a href="mailto:haykagab@gmail.com" className="text-sm text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer">
                    haykagab@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-telegram-line text-blue-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">{t('footer.telegram')}</p>
                  <a href="https://t.me/haykagab" rel="noopener noreferrer" className="text-sm text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer">
                    @haykagab
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-blue-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">{t('footer.contact')}</p>
                  <p className="text-sm text-gray-700">{t('footer.location')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} ArmeniaSettle. {t('footer.copyright')}
          </p>
          <p className="text-xs text-gray-400">
            {t('footer.motto')}
          </p>
        </div>
      </div>
    </footer>
  );
}
